export enum TipoRecurso {
  sistema = 'Sistema',
  relatorio = 'Relatório',
  agenda = 'Agenda',
}
